<template>
    <div class="container-mobile-bottom-bar">   
        <div class="row mobile-bottom-bar">
            <ul :class="currentLanguage !== 'ru_RU'? 'company-social hebrew-ul':'company-social'">
                <li class="social-phone"><a href="tel:050-8691442"><i class="fa fa-phone"></i></a></li>
                <li class="social-whatsapp"><a href="https://api.whatsapp.com/send?phone=972508691442" target="_blank"><i class="fa fa-whatsapp"></i></a></li>
           </ul>
        </div>
    </div>
</template>

<script>
    export default {}
</script>

<style scoped>
   .container-mobile-bottom-bar{
       display: none;
   }

    @media(max-width:420px){
        
        .container-mobile-bottom-bar{
            position: fixed;
            bottom: 0px;
            background-color:#3fbbc0;
            display: block;
            width: 100%;
            z-index: 200;
        }

        .mobile-bottom-bar{
            display: flex;
            justify-content: center;
        }

        .company-social li{
            /*margin: 0px 15px;*/
        }

        .company-social .social-phone a i{
            border: solid 1px #fff;
            border-radius: 50%;
        }

        .company-social .social-whatsapp a i{
            border: solid 1px #fff;
            border-radius: 50%;
        }

        .mobile-bottom-bar ul{
            display: flex;
            justify-content: space-around;
            width: 100%;
        }
    }
</style>